// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Y1zq","select":"Header_select__1hq2Y","clinic":"Header_clinic__3_kuf"};